import { Pipe, PipeTransform } from '@angular/core';
import { firstValueFrom, of } from 'rxjs';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Media } from '@models/media/media.model';

@Pipe({
  name: 'media',
})
export class MediaPipe implements PipeTransform {
  constructor(private api: CommonVerbsApiService) {
    //
  }
  async transform(id: string) {
    if (id) {
      return await firstValueFrom(this.api.get<Media>(`media/${id}`)).then(
        response => {
          return (
            response?.url ??
            'https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable'
          );
        }
      );
    }
    return of('https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable');
  }
}
